<template>
    <div>
        <Logo></Logo>
        <div class="container-fluid bg-3 text-center">
            <div class="block_container drop">
                <div v-for="index in 220" :key="index" :class="`block block_${index}`"></div>
                <div class="clearfix"></div>
            </div>
        </div>
        <!-----------------contents-------------->
        <div class="main">

            <div class="animated_modal_contents about_contents none">
                <div class="col-md-12 member_big pl0 pr0">
                    <div class="logoText">
                        {{dataAboutColumn1.short_desc}}
                    </div>
                    <div class="col-md-12 text-center">
                        <img :src="`${IMAGEURL}cms/${dataAboutColumn1.image}`" class="responsive aboutLogo" alt="theSTEPs.org">
                    </div>
                    <div class="col-md-12 aboutSummary aboutSummaryMargin" v-html="dataAboutColumn1.description"></div>
                    <div class="clearfix"></div>
                </div>
                <div class="mobileShow">
                    <div class="col-md-12 member_big pl0 pr0">
                        <p class="text-center howSummary">{{dataAboutColumn2.short_desc}}</p>
                        <p>
                            <a :href="`${IMAGEURL}cms/${dataAboutColumn2.image}`" class="example-image-link text-center" data-lightbox="example-1">
                                <span class="roll"></span>
                                <img :src="`${IMAGEURL}cms/${dataAboutColumn2.image}`" class="responsive radius example-image howWork" style="max-height: 100%; max-width: 95%">
                            </a>
                        </p>
                    </div>
                    <div class="aboutStepContainer">
                        <div v-for="(row, key) in dataAboutColumn3" :key="key">
                            <div :class="aboutStepClass(key)">
                                <div class="headingLogo">{{row.title}}:</div>
                                <div class="headingBrown">{{row.short_desc}}</div>
                            </div>
                            <div :class="aboutStepDetailsClass(key)" v-html="row.description.replace(/(<([^>]+)>)/ig,'')"></div>
                            <div class="clearfix"></div>
                        </div>

                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>

            <div id="demo" data-animation="hierarchical-display" data-animation-in="tada" data-animationOut="zoomOut" data-speed="3">
                <a :href="`${baseUrl}`" id="close" data-value="hide"></a>
                <div id="mainTitle"></div>
                <div v-for="x in 62" :key="x" :id="`x${x}`"></div>
            </div>

        </div>

        <div class="main2">

            <!-------------------------------About Menu-------------------------------------------->
            <div class="animated_modal_contents about_contents_col2 none">
                <div class="col-md-12 member_big pl0 pr0">
                    <p class="text-center howSummary">{{dataAboutColumn2.short_desc}}</p>
                    <p>
                        <a :href="`${IMAGEURL}cms/${dataAboutColumn2.image}`" class="example-image-link text-center" data-lightbox="example-1">
                            <span class="roll"></span>
                            <img :src="`${IMAGEURL}cms/${dataAboutColumn2.image}`" class="responsive radius example-image howWork" style="max-height: 100%; max-width: 95%">
                        </a>
                    </p>
                </div>
            </div>
            <!-------------------------------end About Menu-------------------------------------------->
            <!------------material modal 2------------------>
            <div id="demo2" data-animation="hierarchical-display" data-animation-in="tada" data-animationOut="zoomOut" data-speed="3">
                <div v-for="y in 63" :key="y" :id="`y${y}`"></div>
            </div>
        </div>

        <div class="main3">
            <!-------------------------------About Menu-------------------------------------------->
            <div class="animated_modal_contents about_contents_col3 none">

                <div class="aboutStepContainer">
                    <div v-for="(row, key) in dataAboutColumn3" :key="key">
                        <div :class="aboutStepClass(key)">
                            <div class="headingLogo">{{row.title}}:</div>
                            <div class="headingBrown">{{row.short_desc}}</div>
                        </div>
                        <div :class="aboutStepDetailsClass(key)" v-html="row.description.replace(/(<([^>]+)>)/ig,'')"></div>
                        <div class="clearfix"></div>
                    </div>

                    <div class="clearfix"></div>
                </div>

            </div>
            <!------------material modal 3------------------>

            <div id="demo3" data-animation="hierarchical-display" data-animation-in="tada" data-animationOut="zoomOut" data-speed="3">
                <div v-for="z in 63" :key="z" :id="`z${z}`"></div>
            </div>

        </div>
        <!--------------end main 3---------------->
        <input class="blockWidth" type="hidden" value="95">
    </div>
</template>

<script>
  import Logo from './Logo.vue';
  import vueCustomScrollbar from 'vue-custom-scrollbar';

  export default {
    components: {
      Logo,
      vueCustomScrollbar,
    },
    data() {
      return {
        blockWidth: 95,
        blockHeight: 95,
        dataAboutColumn1: [],
        dataAboutColumn2: [],
        dataAboutColumn3: [],
        modalData: {},
      };
    },
    mounted() {
      this.aboutColumn1();
      this.aboutColumn2();
      this.aboutColumn3();
      const that = this;
      window.addEventListener(`resize`, function () {
        const width = $(window)
          .width();
        that.resize_block(width, this.blockWidth);
        if (width > 800) {
          location.reload();
        }
      });

      let effect = 'zoomInUp';
      $('#demo').children().addClass(effect + ' animated');
      let screen_width = '';
      screen_width = $(window).width();
      $(".main").css("left", '0px');

      $('#demo').hierarchicalDisplay({
          speed: 6,
        });
      setTimeout(function () {
        $("#demo").css("background", '#ffffff');
        $('.about_contents').fadeIn();
        $('.about_contents_col2').fadeIn();
        $('.about_contents_col3').fadeIn();
        $('#animationOut').after('<i class="fa fa-times fake_close" aria-hidden="true"></i>');
      }, 1500);

      if (screen_width > 1049) {
        //modal 2
        effect = 'rollIn';
        $('#demo2')
          .children()
          .addClass(effect + ' animated');

        // positioned animated box
        screen_width = $(window)
          .width();

        if (screen_width > 1366) {
          $(".main2")
            .css("left", '535px');
        } else if ((screen_width < 1050) && (screen_width > 767)) {
          $(".main2")
            .css("left", '0px');
          $(".main2")
            .css("top", '615px');
        } else if (screen_width < 768) {
          $(".main2")
            .css("left", '0px');
          $(".main2")
            .css("top", '650px');
        } else {
          $(".main2")
            .css("left", '455px');
        }

        $('#demo2')
          .hierarchicalDisplay({
            speed: 6,
          })
        //modal 3
        effect = 'rotateIn';
        $('#demo3')
          .children()
          .addClass(effect + ' animated');
        // positioned animated box
        screen_width = $(window)
          .width();
        if (screen_width > 1366) {
          $(".main3")
            .css("left", '1070px');
        } else if ((screen_width < 1050) && (screen_width > 767)) {
          $(".main3")
            .css("left", '0px');
          $(".main3")
            .css("top", '1230px');
        } else if (screen_width < 768) {
          $(".main3")
            .css("left", '0px');
          $(".main3")
            .css("top", '1280px');
        } else {
          $(".main3")
            .css("left", '910px');
        }

        $('#demo3')
          .hierarchicalDisplay({
            speed: 6,
          });
      }
    },
    methods: {
      aboutColumn1() {
        this.$http.get(`getAboutColumn1`)
          .then((response) => {
            this.dataAboutColumn1 = response.data;
          })
          .catch((error) => {
            if (error.response.status) {
              this.dataAboutColumn1 = [];
            }
          });
      },
      aboutColumn2() {
        this.$http.get(`getAboutColumn2`).then((response) => {
          this.dataAboutColumn2 = response.data;
        }).catch((error) => {
          if (error.response.status) {
            this.dataAboutColumn2 = [];
          }
        });
      },
      aboutColumn3() {
        this.$http.get(`getAboutColumn3`).then((response) => {
          this.dataAboutColumn3 = response.data;
        }).catch((error) => {
          if (error.response.status) {
            this.dataAboutColumn3 = [];
          }
        });
      },
      aboutStepClass(key) {
        let classString = `aboutStep col-md-4 col-sm-4 text-center `;
        classString += `aboutStep`+parseInt(key+1);
        if (key % 2 !== 0) classString += ` medium_gray`;
        if (key % 2 === 0) classString += ` light_gray`;
        return classString;
      },
      aboutStepDetailsClass(key) {
        let classString = `aboutStepDetails  col-md-8 col-sm-8 text-justify `;
        classString += `aboutStepDetails`+parseInt(key+1);
        if (key % 2 !== 0) classString += ` light_gray blackText`;
        if (key % 2 === 0) classString += ` medium_gray whiteText`;
        return classString;
      },
      set_html(array, total, menuStart) {
        for (var i = 0; i < total; i++) {
          const menuNo = i + menuStart;
          const html = $('.menu' + menuNo)
            .html();
          $('.block_' + array[i])
            .html(html);
        }
      },
      resize_block(width, blockWidth) {
        let screenWidth = 0;
        let blockCount = 0;
        let newBlockSize = 0;
        screenWidth = width - 10;
        blockCount = screenWidth / blockWidth;
        blockCount = Math.round(blockCount);
        newBlockSize = screenWidth / blockCount;
        newBlockSize = newBlockSize - .25;
        $('.block')
          .css({ 'width': newBlockSize });
        this.blockWidth = newBlockSize;
        $(".blockWidth")
          .val(newBlockSize);

        let height = $(window)
          .height();
        if (height >= 1025) {
          $('.block_container')
            .css({ 'height': height + 'px' });
        }
      },
    },
  };
</script>
